import React from 'react';
import QuizBar from '../QuizBar/QuizBar';

const Statics = () => {
    return (
        <div className='mt-5'>
            <QuizBar></QuizBar>
        </div>
    );
};

export default Statics;